import { IMAGE_URL_PREFIX } from '../../constants';

export const CHALLENGE_LIST = [
  {
    label: '2곳에 기부하면',
    benefit: '10만원\n백화점 상품권',
    image: {
      url: `${IMAGE_URL_PREFIX}/stamp-2-challenge-benefit-1.png`,
      alt: '신세계상품권 이미지',
    },
    challengeCount: 2,
  },
  {
    label: '5곳에 기부하면',
    benefit: '50만원 상당\n다이슨 슈퍼 소닉',
    image: {
      url: `${IMAGE_URL_PREFIX}/stamp-2-challenge-benefit-2.png`,
      alt: '다이슨 슈퍼 소닉 이미지',
    },
    challengeCount: 5,
  },
  {
    label: '7곳에 기부하면',
    benefit: '100만원 상당\n국내 여행 상품권',
    image: {
      url: `${IMAGE_URL_PREFIX}/stamp-2-challenge-benefit-3.png`,
      alt: '국내 여행 상품권 이미지',
    },
    challengeCount: 7,
  },
] as const;
